import React from "react";
import ReactApexChart from "react-apexcharts";

const AppointmentBarChart = ({ data }) => {
  // Extract unique month names for categories
  const uniqueMonthNames = [...new Set(data.flatMap(day => day["0"].map(item => item.MonthNames)))];

  // Get all unique status types (groups)
  const statusTypes = [...new Set(data.flatMap(day => day["0"].map(item => item.group)))];

  // Create a map of group to color code
  const groupColors = {};
  data.flatMap(day => day["0"]).forEach(item => {
    groupColors[item.group] = item.ColorCode;
  });

  // Prepare series data for each status type
  const series = statusTypes.map(status => {
    return {
      name: status,
      data: uniqueMonthNames.map(month => {
        // Find matching entry for this month and status
        const entry = data
          .flatMap(day => day["0"])
          .find(item => item.MonthNames === month && item.group === status);

        // Return the data value or 0 if not found
        return entry ? entry.data[0] : 0;
      })
    };
  });

  // Get colors in the same order as the series
  const colors = statusTypes.map(status => groupColors[status]);

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
    },
    colors: colors, // Use the colors from the data
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '13px',
              fontWeight: 900
            }
          }
        }
      },
    },
    dataLabels: {
      enabled: false // <-- yahan add kiya gaya hai
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: uniqueMonthNames,
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins',
          fontWeight: 400,
          colors: ['#434343'],
        },
        formatter: function (val) {
          return val;
        }
      }
    },
    yaxis: {
      labels: {
        offsetY: 0,
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins',
          fontWeight: 400,
          colors: ['#434343'],
        },
      },
      title: {
        text: undefined
      },
    },
    tooltip: {
      enabled: true,
      shared: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        // Month name (day)
        const dayName = uniqueMonthNames[dataPointIndex];
        // Us din ke saare groups (statusTypes)
        const dayData = data.flatMap(day => day["0"]).filter(item => item.MonthNames === dayName);

        // Tooltip content
        let rows = dayData.map(item => `
          <div class='d-flex justify-content-between mt-1'>
            <span class='xsm_text pe-2'>${item.group}</span>
            <span class='xsm_text'>${item.data[0]}</span>
          </div>
        `).join('');

        return `
          <div class="apexcharts-tooltip-title pt-0 mt-0">
            <div class="xsm_heading app_border py-2 text-center border-end-0 border-start-0 border-top-0">
              <strong>${dayName}</strong>
            </div>
            <div class="content">${rows}</div>
          </div>
        `;
      }
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      // offsetX: 0 // Set to 0 for proper left alignment
    }
  };

  return (
    <div style={{ width: '100%' }} className="appointment-bar-chart">
      <div id="chart" style={{ width: '100%' }}>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={210}
        />
      </div>
      <style>
        {`
      .appointment-bar-chart .apexcharts-legend {
        justify-content: flex-start !important;
      }
    `}
      </style>
    </div>
  );

}
export default AppointmentBarChart;